import { render, staticRenderFns } from "./ContentNotFound.vue?vue&type=template&id=2acd1ce3&scoped=true&"
import script from "./ContentNotFound.vue?vue&type=script&lang=js&"
export * from "./ContentNotFound.vue?vue&type=script&lang=js&"
import style0 from "./ContentNotFound.vue?vue&type=style&index=0&id=2acd1ce3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acd1ce3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VImg,VRow})
